import { render, staticRenderFns } from "./lp-investment-like-no-other-iii.vue?vue&type=template&id=3ac2b521&scoped=true"
import script from "./lp-investment-like-no-other-iii.vue?vue&type=script&lang=js"
export * from "./lp-investment-like-no-other-iii.vue?vue&type=script&lang=js"
import style0 from "./lp-investment-like-no-other-iii.vue?vue&type=style&index=0&id=3ac2b521&prod&scoped=true&lang=css"
import style1 from "./lp-investment-like-no-other-iii.vue?vue&type=style&index=1&id=3ac2b521&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac2b521",
  null
  
)

export default component.exports